<template>
	<validation-observer ref="refForm">
		<b-form
			@submit.prevent="onSubmit"
			@reset.prevent="resetForm"
		>
			<b-row>
				<b-col md="12">
					<b-card
						footer-tag="footer"
						class="mb-0"
					>
						<!-- FILA 1: ROL, NOMBRES, APELLIDOS -->
						<b-row>
							<b-col cols="12" md="4" class="mb-2">
								<label for="role"><strong>ROL</strong></label>
								<validation-provider #default="{ errors }" rules="required" name="rol">
									<v-select
										id="role"
										v-model="formData.role"
										:state="errors.length > 0 ? false : null"
										:options="roleOptions"
										placeholder="Seleccione un rol"
										@input="onRoleChange"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col cols="12" md="4" class="mb-2">
								<label for="names"><strong>NOMBRES</strong></label>
								<validation-provider #default="{ errors }" rules="required" name="nombres">
									<b-form-input
										id="names"
										v-model="formData.names"
										placeholder="Ingrese los nombres ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col cols="12" md="4" class="mb-2">
								<label for="surnames"><strong>APELLIDOS</strong></label>
								<validation-provider #default="{ errors }" rules="required" name="apellidos">
									<b-form-input
										id="surnames"
										v-model="formData.surnames"
										placeholder="Ingrese los apellidos ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>
						</b-row>

						<!-- FILA 2: CORREO, CORREO SECUNDARIO, TELÉFONO -->
						<b-row>
							<b-col cols="12" md="4" class="mb-2">
								<label for="email"><strong>CORREO ELECTRÓNICO</strong></label>
								<validation-provider #default="{ errors }" rules="required|email" name="correo electrónico">
									<b-form-input
										id="email"
										v-model="formData.email"
										placeholder="Ingrese el correo electrónico ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col cols="12" md="4" class="mb-2">
								<label for="secondaryEmail">
									<strong>CORREO ELECTRÓNICO SECUNDARIO</strong>
									<small class="text-muted ml-1">(Opcional)</small>
								</label>
								<validation-provider #default="{ errors }" rules="email" name="correo electrónico secundario">
									<b-form-input
										id="secondaryEmail"
										v-model="formData.secondary_email"
										placeholder="Ingrese el correo electrónico secundario ..."
										:state="errors.length > 0 ? false : null"
										trim
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col cols="12" md="4" class="mb-2">
								<label for="phone"><strong>TELÉFONO</strong></label>
								<validation-provider #default="{ errors }" rules="integer|min:9" name="teléfono">
									<b-form-input
										id="phone"
										v-model="formData.phone"
										:state="errors.length > 0 ? false : null"
										placeholder="Ingrese teléfono ..."
										trim
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>
						</b-row>

						<!-- FILA 3: DEPARTAMENTO, CARGO -->
						<b-row>
							<b-col cols="12" md="6" class="mb-2">
								<label for="department"><strong>DEPARTAMENTO</strong></label>
								<validation-provider #default="{ errors }" rules="required" name="departamento">
									<v-select
										id="department"
										v-model="formData.department"
										:state="errors.length > 0 ? false : null"
										:options="options.departments"
										:taggable="true"
										:create-option="(name) => ({ value: null, label: name })"
										placeholder="Seleccione o escriba un departamento ..."
										:disabled="!formData.role"
										@input="loadPositions"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>

							<b-col cols="12" md="6" class="mb-2">
								<label for="position"><strong>CARGO</strong></label>
								<validation-provider #default="{ errors }" rules="required" name="cargo">
									<v-select
										id="position"
										v-model="formData.position"
										:options="options.positions"
										:taggable="true"
										:create-option="(name) => ({ value: null, label: name })"
										placeholder="Seleccione o escriba un cargo ..."
										:disabled="!formData.role"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-col>
						</b-row>

						<!-- ACCESS LEVELS -->
						<b-row class="mt-1">
							<b-col cols="12" class="mb-2">
								<label>
									<strong>NIVELES DE ACCESO</strong>
								</label>
								<div class="d-flex flex-wrap mt-1">
									<b-form-checkbox
										v-model="formData.accessLevelUsuario"
										class="mr-3 mb-1"
									>
										Usuario
									</b-form-checkbox>
									<b-form-checkbox
										v-model="formData.accessLevelJefatura"
										class="mr-3 mb-1"
									>
										Jefatura
									</b-form-checkbox>
									<b-form-checkbox
										v-model="formData.accessLevelSuperintendencia"
										class="mb-1"
									>
										Superintendencia
									</b-form-checkbox>
								</div>
							</b-col>
						</b-row>

						<!-- NOTE: CREDENTIALS -->
						<b-row>
							<b-col cols="12" class="mb-2">
								<b-form-checkbox
									:checked="true"
									disabled
								>
									Las credenciales de acceso se enviarán automáticamente al correo electrónico del usuario al crear la cuenta.
								</b-form-checkbox>
							</b-col>
						</b-row>

						<template #footer>
							<!-- BUTTON SUBMIT -->
							<b-button-loading
								text="CREAR"
								type="submit"
								:processing="processing"
							></b-button-loading>

							<b-button
								v-if="!processing"
								v-ripple.400="'rgba(186, 191, 199, 0.15)'"
								type="button"
								variant="outline-secondary"
								class="ml-2"
								:to="{ name: 'user-management-list' }"
							>CANCELAR</b-button>
						</template>
					</b-card>
				</b-col>
			</b-row>
		</b-form>
	</validation-observer>
</template>

<script>
import BButtonLoading from "@core/components/b-button-loading/BButtonLoading.vue"
import { ref, computed, onBeforeMount, onUnmounted } from "@vue/composition-api"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { required, email, integer, min } from "@validations"
import userManagementStoreModule from "../userManagementStoreModule"
import useNotifications from "@notifications"
import Ripple from "vue-ripple-directive"
import vSelect from "vue-select"
import router from "@/router"
import store from "@/store"
import axios from "@axios"

export default {
	components: {
		ValidationProvider,
		ValidationObserver,

		BButtonLoading,

		required,
		email,
		integer,
		min,
		vSelect
	},
	directives: {
		Ripple
	},
	setup() {
		// USE TOAST
		const { toastNotification } = useNotifications()

		// REFS
		const refForm = ref(null)

		const formData = ref({
			role: null,
			department: null,
			position: null,
			names: null,
			surnames: null,
			email: null,
			secondary_email: null,
			phone: null,
			accessLevelUsuario: false,
			accessLevelJefatura: false,
			accessLevelSuperintendencia: false
		})

		const processing = ref(false)
		const options = ref({})

		const roleOptions = [
			{ value: 2, label: 'Administrador' },
			{ value: 3, label: 'Gestor' }
		]

		const isAdmin = computed(() => formData.value.role && formData.value.role.value === 2)
		const isManager = computed(() => formData.value.role && formData.value.role.value === 3)

		const USER_MGMT_STORE_NAME = "app-user-management"

		// REGISTER MODULE
		if (!store.hasModule(USER_MGMT_STORE_NAME))
			store.registerModule(USER_MGMT_STORE_NAME, userManagementStoreModule)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(USER_MGMT_STORE_NAME))
				store.unregisterModule(USER_MGMT_STORE_NAME)
		})

		// CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
		onBeforeMount(() => {
			getSelectFilters()
		})

		const getSelectFilters = async () => {
			try {
				const { data } = await axios.get("/selectors/departments")
				options.value = {
					departments: data.departments,
					positions: []
				}
			} catch (error) {
				toastNotification(error.response.data.message, false)
			}
		}

		const loadPositions = async (department) => {
			formData.value.position = null
			if (!department || !department.value) {
				options.value.positions = []
				return
			}
			try {
				const { data } = await axios.get("/selectors/positions", {
					params: { department_id: department.value }
				})
				options.value.positions = data.positions
			} catch (error) {
				toastNotification(error.response.data.message, false)
			}
		}

		const onRoleChange = () => {
			formData.value.department = null
			formData.value.position = null
			options.value.positions = []
		}

		const resetFormData = () => {
			formData.value = {
				role: null,
				department: null,
				position: null,
				names: null,
				surnames: null,
				email: null,
				secondary_email: null,
				phone: null,
				accessLevelUsuario: false,
				accessLevelJefatura: false,
				accessLevelSuperintendencia: false
			}
		}

		const onSubmit = async () => {
			const isValid = await refForm.value.validate()

			if (!isValid) {
				const message = "Complete los campos requeridos."
				toastNotification(message, false)
				return
			}

			processing.value = true

			const access_levels = []
			if (formData.value.accessLevelUsuario) access_levels.push(1)
			if (formData.value.accessLevelJefatura) access_levels.push(2)
			if (formData.value.accessLevelSuperintendencia) access_levels.push(3)

			const payload = {
				names: formData.value.names,
				surnames: formData.value.surnames,
				email: formData.value.email,
				secondary_email: formData.value.secondary_email,
				phone: formData.value.phone,
				role: formData.value.role.value,
				department_name: formData.value.department ? formData.value.department.label : null,
				position_name: formData.value.position ? formData.value.position.label : null,
				access_levels
			}

			store
				.dispatch("app-user-management/createUser", payload)
				.then((response) => {
					setTimeout(() => {
						processing.value = false
						toastNotification(response.data.message)
						resetFormData()
						refForm.value.reset()
						router.push({ name: "user-management-list" })
					}, 2000)
				})
				.catch((error) => {
					processing.value = false
					const message =
						error.response.data.message || "Error al crear el usuario"
					toastNotification(message, false)
				})
		}

		return {
			// DATA
			processing,
			formData,
			options,
			roleOptions,
			isAdmin,
			isManager,

			// REFS
			refForm,

			// METHODS
			onRoleChange,
			loadPositions,
			onSubmit
		}
	}
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
